<div class="insurance-app-component">
  <mat-card appearance="outlined">
    <mat-tab-group [mat-stretch-tabs]="false" mat-align-tabs="start">
      <mat-tab label="APPLICANT"><div *ngTemplateOutlet="applicantTab;"></div></mat-tab>
      <mat-tab label={{getOrganisationTypeForTitle(application)}}><div *ngTemplateOutlet="directorsTab"></div></mat-tab>
      <mat-tab label="AUTHORISED SIGNATORY"><div *ngTemplateOutlet="authorisedSignatoryTab"></div></mat-tab>
      <mat-tab label="POLICIES"><div *ngTemplateOutlet="policiesTab"></div></mat-tab>
    </mat-tab-group>
  </mat-card>
</div>

<ng-template #applicantTab>
  <div class="row separator header flex space-between align-center"
    fxLayout="row"
    fxLayoutGap="10px"
    fxLayoutAlign="space-between center"
    fxLayout.lt-md="column"
    fxLayoutAlign.lt-md="center start">
    @if (applicationStatus && applicationStatus==='Under Review') {
      <div class="col-md-3 under-review">
        <status-box type="under-review"></status-box>
      </div>
    } @else {
      <div></div>
    }
    <div fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="start center"
      fxLayout.lt-md="column"
      fxLayoutAlign.lt-md="center start">
      @if (applicationStatus !== 'Closed' && application.AppInfoSalesforceID) {
        <button mat-flat-button class="inactive ml-2 w-lt-md-100" (click)="onWithdrawApplication()">
          <span class="mdi mdi-arrow-u-left-bottom" matPrefix></span>
          Withdraw Application
        </button>
      }   
      @if (applicationStatus !== 'Closed' && 
          application.AppInfoStageName !== 'Draft' && 
          !application.AppInfoSalesforceID &&
          (user?.AccessLevel ?? '') === 'admin' && 
          !application.SystemCreditStatus
      ) {
        <button mat-flat-button class="inactive ml-2 w-lt-md-100" (click)="sendToDraft()">
          <span class="mdi mdi-arrow-u-left-bottom" matPrefix></span>
          Back To Draft
        </button>
      }
    </div>
  </div>

  <div class="section">
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Application ID</div>
          <div body>{{getBrokerApplicationId(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Salesforce ID</div>
          <div body>{{getAppSalesforceId(application)}}</div>
        </cell>
      </div>

    </div>



    <div class="row reduced-row">
      <div class="col-lg-6 col-md-12">
        <cell>
          <div label>Introducer</div>
          <div body>
            <searchable-select 
              [formControl]="brokerControl"
              [items]="brokerCompanies"
              [multi]="false"
              (selectionChange)="onBrokerChange($event)"
              [isEditable]="isAdminUser() && isApplicationStage()"
            />
          </div>
        </cell>
      </div>
      
      <div class="col-lg-6 col-md-12">
        <cell>
          <div label>Contact</div>
          <div body>
            <searchable-select 
              [formControl]="submitterControl"
              [items]="submitterUsers"
              [multi]="false"
              (selectionChange)="onSubmitterChange($event)"
              [isEditable]="isAdminOrSalesUser()"
            />
          </div>
        </cell>
      </div>
    </div>

        <div class="row reduced-row-gap">
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Sales Contact</div>
              <div body>
                <searchable-select
                  [formControl]="salesContactControl"
                  [items]="salesContactUsers"
                  [multi]="false"
                  (selectionChange)="onSalesContactChange($event)"
                  [isEditable]="isAdminUser()">
                </searchable-select>
              </div>
            </cell>
          </div>
        
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Credit Officer</div>
              <div body>
                <searchable-select 
                  [formControl]="creditOfficerControl"
                  [items]="creditOfficerUsers"
                  [multi]="false"
                  (selectionChange)="onCreditOfficerChange($event)"
                  [isEditable]="isAdminOrCredit()"
                />
              </div>
            </cell>
          </div>
        </div>

        <div class="row reduced-row-gap">
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Settlement Officer</div>
              <div body>
                <searchable-select 
                  [formControl]="settlementControl"
                  [items]="settlementUsers"
                  [multi]="false"
                  (selectionChange)="onSettlementOfficerChange($event)"
                  [isEditable]="isAdminOrOperationUser()"
                />
              </div>
            </cell>
          </div>
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>AML Officer</div>
              <div body>
                <searchable-select
                  [formControl]="amlOfficerControl"
                  [items]="amlOfficerUsers"
                  [multi]="false"
                  (selectionChange)="onAmlOfficerChange($event)"
                  [isEditable]="canEditAmlOfficer"
                />
              </div>
            </cell>
          </div>
          @if (application.AdditionalBrokerCorrespondent && AdditionalBrokerCorrespondentUserId) {
              <div class="col-lg-6 col-md-12">
                <cell>
                  <div label>Additional Correspondant Contact</div>
                  <div body>
                    <searchable-select 
                      [formControl]="additionalCorrespondentControl"
                      [items]="additionalCorrespondentUsers"
                      [multi]="false"
                      (selectionChange)="onAdditionalCorrespondentChange($event)"
                      [isEditable]="isAdminUser()"
                    />
                  </div>
                </cell>
              </div>
            }
          </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>

  <div class="row">
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Premium amount</div>
        <div body><span class="mdi mdi-currency-usd"></span>{{getTotalAmount(application) | looseCurrency:'':''}}</div>
      </cell>
    </div>
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Application fee</div>
        @if (data && data.applicationFee) {
          <div body><span class="mdi mdi-currency-usd"></span>{{(data.applicationFee != undefined ? data.applicationFee : getDocFee(application)) | looseCurrency:'':''}}</div>
        }
      </cell>
    </div>

    <div class="col-lg-6 col-md-12">
      <cell>
        <div label>Repayment</div>
        @if (data && data.monthlyInstallment) {
          <div body><span class="mdi mdi-currency-usd"></span>{{(data.monthlyInstallment != undefined ? data.monthlyInstallment : getRepayment(application)) | looseCurrency:'':''}} paid in {{getLoanTerms(application)}} {{getPaymentPeriod(application)}} installments</div>
        }
      </cell>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>

  <div class="section">
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>ABN Age</div>
          <div body>{{getAbnAge(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>ABN Age (with continuity)</div>
          <div body>{{getAbnAgeWithContinuity(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>GST Age</div>
          <div body>{{getGstAge(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>GST Age (with continuity)</div>
          <div body>{{getGstAgeWithContinuity(application)}}</div>
        </cell>
      </div>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>

  <div class="section">
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Company name</div>
          <div body>{{getCompanyName(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Organisation type</div>
          <div body>{{getOrganisationType(application)}}</div>
        </cell>
      </div>
    </div>
    <mat-divider [inset]="true"></mat-divider>
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>ABN</div>
          <div body>{{getAbn(application)}}</div>
        </cell>
      </div>
      @if (getOrganisationType(application)==='Company') {
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>ACN</div>
            <div body>{{getAcn(application)}}</div>
          </cell>
        </div>
      }
    </div>
    <mat-divider [inset]="true"></mat-divider>
  </div>


  <div class="section">
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <cell>
          <div label>Finance type</div>
          <div body>{{getFinanceType(application)}}</div>
        </cell>
      </div>
    </div>
    <mat-divider [inset]="true"></mat-divider>
    <loan-purpose-summary [loanPurpose]="application.AppInfo.LoanPurpose ?? null"></loan-purpose-summary>
    <mat-divider [inset]="true"></mat-divider>
  </div>

  <div class="section">
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Revenue</div>
          <div body><span class="mdi mdi-currency-usd"></span>{{getRevenue(application) | looseCurrency:'':''}}</div>
        </cell>
      </div>
      @if (getLimitRequest(application)) {
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Limit request</div>
            <div body>{{getLimitRequest(application)}}</div>
          </cell>
        </div>
      }
    </div>
    <mat-divider [inset]="true"></mat-divider>
    <div class="row anzsic-row">
      <div class="col-lg-6 col-md-12">
        <cell>
          <div label>Primary industry</div>
          <div body>{{getApplicationPrimaryIndustry(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Industry sector</div>
          <div body>{{getIndustrySector(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Industry class</div>
          <div body>{{getSubdivisionSector(application)}}</div>
        </cell>
      </div>
      @if (canEditAnzsic()) {
        <button mat-icon-button class="edit-anzsic-btn" (click)="onEditAnzsic()" matTooltip="Edit ANZSIC Code">
          <span class="mdi mdi-pencil-outline"></span>
        </button>
      }
    </div>
    <mat-divider [inset]="true"></mat-divider>
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <cell>
          <div label>Principal place of business address</div>
          <div body>{{getPrimaryBusinessAddress(application)}}</div>
        </cell>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <cell>
          <div label>Registered business address</div>
          <div body>{{getRegisteredBusinessAddress(application)}}</div>
        </cell>
      </div>
    </div>
    <mat-divider [inset]="true"></mat-divider>
  </div>

  @if (getApplicationNotes(application)) {
    <div class="section">
      <div class="row">
        <div class="col-12">
          <div class="mat-h3">Application notes</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <cell>
            <div body>{{getApplicationNotes(application)}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
    </div>
  }
</ng-template>


<ng-template #directorsTab>
  <individual-details [applicationId]="application.ApplicationId" type="all-non-guarantors"></individual-details>
</ng-template>
<ng-template #authorisedSignatoryTab>
  <authorised-signatories-details [application]="application"></authorised-signatories-details>
</ng-template>
<ng-template #policiesTab>
  <policies-details [application]="application"></policies-details>
</ng-template>
